import { CalendarRange } from './CalendarRange';

export class Calendar {
    label: string;
    //TODO: change this to CalendarType
    type: string;
    ranges: Array<CalendarRange>;

    constructor(init?: Partial<Calendar>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): Calendar {
        const calendar = new Calendar();
        Object.assign(calendar, obj);
        calendar.ranges = obj.ranges.map((c: any) => {
            return CalendarRange.Make(c);
        });
        return calendar;
    }
}
